import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import LoadingButton from '@components/atoms/loadingButton';

const ProductDetailStyle = withTheme(styled(Box)`
  padding-bottom: 70px;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0));
  }
  .custom-glance {
    font-family: Lanna;
    font-size: 18px;
  }
  .custom-glance i {
    margin-top: 2px;
    margin-right: 16px;
  }
  .default-glance {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
  }
  .default-glance i {
    font-size: 33px;
    width: 33px;
    color: #00532a;
  }
  .default-glance .subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    font-family: Lanna;
  }
  .container {
    max-width: 1180px;
  }
  .course-description-title-desktop {
    ${(props: any) => props.theme.breakpoints.down('lg')} {
      display: none;
    }
  }
  .course-description-title-mobile {
    ${(props: any) => props.theme.breakpoints.up('lg')} {
      display: none;
    }
  }
  .MuiTabs-indicator {
    height: 6px;
    border-radius: 3px;
    background: #00532a;
  }

  ${(props: any) => props.theme.breakpoints.up('lg')} {
    .container {
      margin: 0 auto;
      height: 100%;
      padding: 0rem 1rem;
      position: relative;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .container {
      margin: 0rem auto;
      height: 100%;
      padding: 0 1rem;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    .container {
      max-width: 1150px;
      height: 100%;
    }
  }
`);

export const LoadingContainer = withTheme(styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
`);

export default ProductDetailStyle;
